import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

/** Shown at the top of setup when the user opened the game via “trial” from the mode detail screen. */
export function PartyTrialSetupBanner() {
  const { t } = useTranslation();
  return (
    <Box
      role="status"
      sx={{
        mb: 2,
        p: 1.75,
        borderRadius: 2,
        border: "1.5px solid color-mix(in oklab, var(--hot) 35%, transparent)",
        bgcolor: "color-mix(in oklab, var(--hot) 10%, transparent)",
      }}
    >
      <Typography sx={{ fontSize: 14, fontWeight: 800, color: "var(--ink)", lineHeight: 1.45 }}>
        {t("party.trial.setupBanner")}
      </Typography>
      <Typography className="party-mono" sx={{ mt: 1, fontSize: 11, color: "var(--ink-dim)", fontWeight: 700, lineHeight: 1.4 }}>
        {t("party.trial.setupBannerSub")}
      </Typography>
    </Box>
  );
}
